import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge Tailwind classes sans conflits */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/** Tronque un texte à N caractères */
export function truncate(text: string, max = 100): string {
  if (text.length <= max) return text
  return text.slice(0, max) + '...'
}

/** Génère des initiales depuis un nom complet */
export function getInitials(firstName: string, lastName: string): string {
  return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase()
}

/** Délay (Promise) */
export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))

/** Capitalize first letter */
export function capitalize(str: string): string {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

/** Slugify */
export function slugify(str: string): string {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

/** Vérifie si une valeur est vide (null, undefined, '', [], {}) */
export function isEmpty(value: unknown): boolean {
  if (value === null || value === undefined) return true
  if (typeof value === 'string') return value.trim() === ''
  if (Array.isArray(value)) return value.length === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  return false
}
